import React, { useEffect, useState } from "react";
import { Navigate} from "react-router-dom";
import { PrivateRouteProps } from "./type";
import { useSupabaseAuth } from "../Context/AuthContext/AuthContext";

const isAuthenticated = (user: any): boolean => {
  return !!user;
};

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { useAuthStore } = useSupabaseAuth();
  const user = useAuthStore((state: any) => state.user);
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    // Simulate checking auth status
    const checkAuth = setTimeout(() => {
      setIsLoading(false);
    }, 100);
    
    return () => clearTimeout(checkAuth);
  }, [user]);

  if (isLoading) {
    // You can replace this with a proper loading component if needed
    return <div style={{ height: '100vh', width: '100vw', background: '#000513' }}></div>;
  }

  return isAuthenticated(user) ? (
    <>{children}</>
  ) : (
    <Navigate to="/welcome" replace />
  );
};
